import React from 'react';
import { useTranslation } from '../i18n/useTranslation';

const SuccessModal = ({ onClose }) => {
  const { t, language } = useTranslation();
  const isRTL = language === 'ar';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="bg-white rounded-xl sm:rounded-2xl shadow-2xl max-w-md w-full p-6 sm:p-8 text-center animate-slide-in" dir={isRTL ? 'rtl' : 'ltr'}>
        <div className="mb-4 sm:mb-6">
          <div className="mx-auto w-16 h-16 sm:w-20 sm:h-20 bg-green-100 rounded-full flex items-center justify-center mb-3 sm:mb-4 animate-bounce">
            <svg className="w-10 h-10 sm:w-12 sm:h-12 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">{t('booking.success')}</h2>
          <p className="text-sm sm:text-base text-gray-600 px-2">{t('booking.successMessage') || 'Your appointment has been booked successfully!'}</p>
        </div>
        <button
          onClick={onClose}
          className="w-full px-4 sm:px-6 py-2.5 sm:py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg hover:from-blue-700 hover:to-indigo-700 transition font-semibold shadow-md hover:shadow-lg text-sm sm:text-base"
        >
          {t('close')}
        </button>
      </div>
    </div>
  );
};

export default SuccessModal;

